/** The fields any programme DTO carries; both the list item and the view DTO satisfy it. */
export interface NameableProgramme {
  labName?: string | null;
  institutionName?: string | null;
}

/**
 * The name a screen shows for a certification programme.
 *
 * Every screen used `labName` as the programme's name, which holds only while a programme belongs
 * to a laboratory (HS-1366). A programme scoped to the whole institution has `labId: null` and
 * therefore no `labName`, so without a fallback the row title, the delete confirmation and the page
 * heading all render empty.
 *
 * The caller chooses the fallback because the right one depends on what sits beside the name: the
 * view and edit headers already show the institution in a badge, so they pass a generic
 * "whole institution" label rather than repeat it, while a list row has no such neighbour and
 * passes the institution's own name.
 */
export function certificationProgramName(
  programme: NameableProgramme,
  whenInstitutionScoped: string,
): string {
  const labName = programme.labName ?? '';
  return labName === '' ? whenInstitutionScoped : labName;
}
